import { render, staticRenderFns } from "./appAssetFormats.vue?vue&type=template&id=be668354&scoped=true"
import script from "./appAssetFormats.vue?vue&type=script&lang=js"
export * from "./appAssetFormats.vue?vue&type=script&lang=js"
import style0 from "./appAssetFormats.vue?vue&type=style&index=0&id=be668354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be668354",
  null
  
)

export default component.exports